export const defaultTranslations = {
  addPlayer: (playerName?: string) =>
    playerName ? `Add player ${playerName}` : "Add player",
  back: "Back",
  captain: "Captain",
  carouselPanel: {
    scrollLeft: "Scroll left",
    scrollRight: "Scroll right",
  },
  closeButton: "Close",
  deadlineBar: {
    deadline: (deadlineTime: string, timeProps: { dateTime: string }) => (
      <>
        Deadline: <time {...timeProps}>{deadlineTime}</time>
      </>
    ),
  },
  dialog: {
    closeButton: "Close dialog",
  },
  dreamTeam: "Dream Team",
  elementDialogButton: {
    viewPlayerInformation: "View player information",
  },
  errorFallback: {
    title: "Error",
    errorMessage: "We're sorry - something's gone wrong.",
    reportMessage:
      "Our team has been notified, but click here to fill out a report.",
    reportButton: "Report feedback",
  },
  externalSite: "external site",
  fieldError: {
    valueMissing: "This field is required.",
    typeMismatch: "Invalid format.",
  },
  filterChip: {
    reset: "Reset filters",
    noneSelected: (label: string) => `${label}, none selected`,
    selected: (label: string, chipText: string) =>
      `${label}, ${chipText} selected`,
  },
  filterOptions: "Filter options",
  filterSheet: {
    saveFilterChanges: "Save filter changes",
    saveChanges: "Save changes",
  },
  fixtures: {
    all: "All",
    addFixturesToCalendar: "Add fixtures to calendar",
    broadcasters: "Broadcasters",
    deadline: (deadlineTime: string, timeProps: { dateTime: string }) => (
      <>
        Deadline: <time {...timeProps}>{deadlineTime}</time>
      </>
    ),
    deadlineNote: "*All times are shown in your local time",
    fixture: "Fixture",
    fixtureStats: (homeTeam: string, awayTeam: string) =>
      `Show match stats for ${homeTeam} versus ${awayTeam}`,
    fixtureTimeAbbreviation: "FT",
    fixtures: "Fixtures",
    multipleBroadcasters: "Multiple Broadcasters",
    noFixture: "No fixture",
    viewBroadcasters: "View broadcasters",
    watchLiveOn: "Watch Live On",
  },
  formSelect: {
    placeholder: "Select an option",
  },
  gameTabs: {
    navLabel: "Fantasy games",
    classic: "Fantasy",
    challenge: "FPL Challenge",
    draft: "FPL Draft",
  },
  matchDetails: "Match details",
  moreInfo: "More info",
  nextGameweek: "Next gameweek",
  noDataAvailable: "No data available",
  noStatsAvailable: "No stats available",
  notApplicableAbbreviation: "N/A",
  opensInNewTab: "Opens in new tab",
  paginator: {
    first: "First",
    last: "Last",
    next: "Next",
    pageOfTotal: (page: number, totalPages: number) => (
      <>
        <strong>{page}</strong> of {totalPages}
      </>
    ),
    previous: "Previous",
  },
  player: "Player",
  playerNotes: {
    label: "Player notes",
    tooltipText: "View status update on player profile",
  },
  playerStats: "Player stats",
  points: "points",
  pointsAbbreviation: "Pts",
  popoverSelectLabel: "Select an option",
  previousGameweek: "Previous gameweek",
  removePlayer: (playerName?: string) =>
    playerName ? `Remove player ${playerName}` : "Remove player",
  rowLoading: "row loading",
  scoreboard: {
    bank: "Bank",
    budget: "Budget",
    cost: "Cost",
    freeHit: "free hit",
    freeTransfers: "Free transfers",
    playersSelected: "Players selected",
    transferCostsValue: (costs: number) => `${costs} pts`,
    unlimited: "Unlimited",
    wildcard: "wildcard",
  },
  searchField: {
    placeholder: "Search",
    cancelButton: "Cancel",
  },
  statsAbbreviation: "Stats",
  status: "Status",
  switchPlayer: "Switch player",
  teamName: "Team Name",
  toBeConfirmedAbbreviation: "TBC",
  viceCaptain: "Vice Captain",
};
